export default "__VITE_ASSET__BOp4aZAg__"